import { render } from "./SearchResultsView.vue?vue&type=template&id=07092a8a&lang=pug"
import script from "./SearchResultsView.vue?vue&type=script&lang=js"
export * from "./SearchResultsView.vue?vue&type=script&lang=js"

import "./SearchResultsView.vue?vue&type=style&index=0&id=07092a8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__